import './Navbar.scss';
import React from 'react';

const CCIcon = () =>
	(window.cchome.util.hasFeature('cc_icon_navbar') ? (
		<img className='cc-branding-icon' src='/assets/common/cc_appicon_88x84.png' />
	) : (
		<svg
			id='Layer_2'
			data-name='Layer 2'
			xmlns='http://www.w3.org/2000/svg'
			viewBox='0 2 48 48'
			className='cc-icon'
		>
			<path
				id='_44x42'
				data-name='44x42'
				d='M43.01317,11.45814A18.33236,18.33236,0,0,0,29.58449,5.99929,17.00963,17.00963,0,0,0,17.1248,11.23442,15.30732,15.30732,0,0,0,.09437,26.45112,15.7685,15.7685,0,0,0,4.38608,37.13905,14.98372,14.98372,0,0,0,15.39376,41.9003h14.5881a18.04753,18.04753,0,0,0,17.9568-18.09683A18.34672,18.34672,0,0,0,43.01317,11.45814ZM15.12139,39.10807A12.28805,12.28805,0,0,1,2.796,26.537c0-6.97347,5.23274-12.7454,12.18984-12.7454a12.88068,12.88068,0,0,1,8.507,3.329l.06212.05369,5.25657,5.39394a2.26068,2.26068,0,0,1-3.245,3.1484l-5.21606-5.35281a8.10117,8.10117,0,0,0-5.2828-1.95918,7.86373,7.86373,0,0,0-7.79438,8.0997A8.06965,8.06965,0,0,0,15.2436,34.681l1.04117.00476.00966.02932c1.49069,2.05666,5.64317,4.393,5.64317,4.393Zm25.99116-4.38192a15.2739,15.2739,0,0,1-11.03924,4.46907,15.10781,15.10781,0,0,1-10.73008-4.59073l-6.94746-6.96224a2.26513,2.26513,0,0,1,1.62066-3.84868,2.24008,2.24008,0,0,1,1.62046.68162l6.89867,6.91787a11.051,11.051,0,0,0,7.712,3.37939,10.46553,10.46553,0,0,0,7.63716-3.22669,10.8803,10.8803,0,0,0,2.79882-7.81932A10.54743,10.54743,0,0,0,30.2082,12.8804a9.709,9.709,0,0,0-6.00866,1.752c-.01992-.01618-.51883-.3469-1.08229-.68923-.34947-.21249-.72584-.42383-1.022-.58452-.3295-.17916-1.27411-.64259-1.83609-.87487-.13985-.05788-.32041-.12414-.39648-.151l.0158-.00857c2.8595-2.673,6.21091-3.575,10.12266-3.575A14.80954,14.80954,0,0,1,45.14992,23.66108,15.48936,15.48936,0,0,1,41.11255,34.72615Z'
			/>
		</svg>
	));

export default CCIcon;
